import React, { useContext } from "react";
import { BrowserRouter as Router, Route, useHistory } from "react-router-dom";

import { AppProvider } from "context/appContext";
import { ContentProvider, ContentContext } from "context/contentContext";
import { DataProvider } from "context/dataContext";
import { GlobalStyle } from "theme/styled/reset";

import Home from "pages/index";
import Products from "pages/products";
import Results from "pages/results";

function App() {
  return (
    <ContentProvider>
      <ContentChildren />
    </ContentProvider>
  );
}

function ContentChildren() {
  const { lang } = useContext(ContentContext);
  return (
    <AppProvider lang={lang}>
      <DataProvider lang={lang}>
        <GlobalStyle whiteColor />
        <Router basename="/reactapp">
          <Route exact path="/" component={Home} />
          <Route exact path="/products" component={Products} />
          <Route exact path="/results" component={Results} />
        </Router>
      </DataProvider>
    </AppProvider>
  );
}

export default App;
